export default __webpack_public_path__ + "static/media/download-white-icon.14ab986e.svg";